import FacebookProductIcon from './icon.svg';

export const facebookProducts = ['messaging', 'page'] as const;
export type FacebookProduct = (typeof facebookProducts)[number];

export const facebookProductIcons: Record<FacebookProduct, string> = {
  messaging: FacebookProductIcon,
  page: FacebookProductIcon,
};

export const facebookProductLabels: Record<FacebookProduct, string> = {
  messaging: 'Personal account',
  page: 'Facebook Pages',
};

export const isFacebookProduct = (value: unknown): value is FacebookProduct => {
  return typeof value === 'string' && value in facebookProductLabels;
};

/** Realtime product of a single Facebook Page, keyed `page_<pageId>`. */
export const isFacebookPageProduct = (value: string): boolean => /^page_\d+$/.test(value);
